var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation } from "@apollo/client";
import BrainSvg from "assets/svg/brain.svg";
import ChevronSvg from "assets/svg/chevron.svg";
import CloseSvg from "assets/svg/close.svg";
import StarSvg from "assets/svg/star.svg";
import moment from "moment";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactModal from "react-modal";
import { useMediaQuery } from "react-responsive";
import { Box, Flex, Text } from "rebass";
import { Button } from "src/components/elements/Button";
import { DISMISS_NEWS } from "src/queries/users";
import { breakpoints, theme } from "src/styles/theme";
import styled from "styled-components";
var modalStyles = {
    overlay: {
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(80,80,80,0.56)",
    },
    content: {
        position: "static",
        overflow: "visible",
        width: "100%",
        maxWidth: "76rem",
        padding: "0.8rem",
        border: "none",
        borderRadius: "0.4rem",
        backgroundColor: theme.colors.white,
        inset: "initial",
        display: "flex",
        flexDirection: "column",
        gap: "1.6rem",
        margin: "6rem 1rem 1rem 1rem",
    },
};
var mobileModalStyles = {
    overlay: {
        overflow: "visible",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "end",
        backgroundColor: "rgba(80,80,80,0.56)",
    },
    content: {
        position: "static",
        overflow: "visible",
        width: "100%",
        padding: "0.8rem",
        border: "none",
        borderRadius: "0.4rem",
        backgroundColor: theme.colors.white,
        inset: "initial",
        display: "flex",
        flexDirection: "column",
        gap: "1.6rem",
        marginTop: "6rem",
        maxHeight: "90vh",
    },
};
var Header = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background: #f0fdfc;\n  padding: 2rem 2rem 3rem;\n  border-radius: 0.4rem;\n  text-align: center;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  gap: 0.8rem;\n  height: 12rem;\n"], ["\n  position: relative;\n  background: #f0fdfc;\n  padding: 2rem 2rem 3rem;\n  border-radius: 0.4rem;\n  text-align: center;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end;\n  gap: 0.8rem;\n  height: 12rem;\n"])));
var IconWrapper = styled(Flex)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0.8rem;\n  position: relative;\n  border-radius: 50%;\n  background: ", ";\n  outline: 8px solid ", ";\n  width: 9rem;\n  height: 9rem;\n  position: absolute;\n  top: -4rem;\n  left: 50%;\n  transform: translateX(-50%);\n"], ["\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0.8rem;\n  position: relative;\n  border-radius: 50%;\n  background: ", ";\n  outline: 8px solid ", ";\n  width: 9rem;\n  height: 9rem;\n  position: absolute;\n  top: -4rem;\n  left: 50%;\n  transform: translateX(-50%);\n"])), theme.colors.secondary, theme.colors.white);
var BrainIcon = styled(BrainSvg)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 5rem;\n  height: 5.4rem;\n  color: ", ";\n  & path {\n    fill: ", ";\n  }\n"], ["\n  width: 5rem;\n  height: 5.4rem;\n  color: ", ";\n  & path {\n    fill: ", ";\n  }\n"])), theme.colors.white, theme.colors.white);
var Star = styled(StarSvg)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  position: absolute;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var size = _a.size;
    return size || "1rem";
}, function (_a) {
    var size = _a.size;
    return size || "1rem";
}, function (_a) {
    var top = _a.top;
    return top && "top: ".concat(top, ";");
}, function (_a) {
    var left = _a.left;
    return left && "left: ".concat(left, ";");
}, function (_a) {
    var right = _a.right;
    return right && "right: ".concat(right, ";");
}, function (_a) {
    var bottom = _a.bottom;
    return bottom && "bottom: ".concat(bottom, ";");
});
var Title = styled(Text)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-size: 1.8rem;\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-size: 1.8rem;\n  font-weight: ", ";\n  color: ", ";\n"])), theme.fontWeights.bold, theme.colors.secondary);
var CloseButton = styled.button(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 3.2rem;\n  height: 3.2rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: ", ";\n  font-size: 1.8rem;\n  line-height: 1;\n  &:hover {\n    opacity: 0.8;\n  }\n\n  @media (max-width: ", ") {\n    top: 0.8rem;\n    right: 0.8rem;\n  }\n"], ["\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 3.2rem;\n  height: 3.2rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: ", ";\n  font-size: 1.8rem;\n  line-height: 1;\n  &:hover {\n    opacity: 0.8;\n  }\n\n  @media (max-width: ", ") {\n    top: 0.8rem;\n    right: 0.8rem;\n  }\n"])), theme.colors.primary, breakpoints.md);
var CloseIcon = styled(CloseSvg)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  width: 1.8rem;\n  height: 1.8rem;\n  color: ", ";\n  & path {\n    fill: ", ";\n  }\n\n  @media (max-width: ", ") {\n    width: 1.2rem;\n    height: 1.2rem;\n  }\n"], ["\n  width: 1.8rem;\n  height: 1.8rem;\n  color: ", ";\n  & path {\n    fill: ", ";\n  }\n\n  @media (max-width: ", ") {\n    width: 1.2rem;\n    height: 1.2rem;\n  }\n"])), theme.colors.primaryDark, theme.colors.primaryDark, breakpoints.md);
var Content = styled(Box)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  padding: 0 3.2rem;\n  overflow-y: auto;\n  user-select: none;\n  max-height: 50vh;\n\n  @media (max-width: ", ") {\n    padding: 0 0.8rem;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 1.6rem;\n  padding: 0 3.2rem;\n  overflow-y: auto;\n  user-select: none;\n  max-height: 50vh;\n\n  @media (max-width: ", ") {\n    padding: 0 0.8rem;\n  }\n"])), breakpoints.md);
var NewsDate = styled(Text)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  font-size: 1.4rem;\n  color: ", ";\n"], ["\n  font-size: 1.4rem;\n  color: ", ";\n"])), theme.colors.gray500);
var NewsTitle = styled(Text)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  font-size: 1.6rem;\n  font-weight: ", ";\n  color: ", ";\n"], ["\n  font-size: 1.6rem;\n  font-weight: ", ";\n  color: ", ";\n"])), theme.fontWeights.bold, theme.colors.black);
var NewsDescription = styled(Text)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  font-size: 1.4rem;\n  color: ", ";\n  line-height: 1.5;\n"], ["\n  font-size: 1.4rem;\n  color: ", ";\n  line-height: 1.5;\n"])), theme.colors.text);
var CheckboxLabel = styled.label(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-size: 1.4rem;\n  color: ", ";\n  cursor: pointer;\n  user-select: none;\n  font-weight: ", ";\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  font-size: 1.4rem;\n  color: ", ";\n  cursor: pointer;\n  user-select: none;\n  font-weight: ", ";\n  flex-shrink: 0;\n"])), theme.colors.text, theme.fontWeights.semibold);
var Checkbox = styled.input.attrs({ type: "checkbox" })(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  width: 1.8rem;\n  height: 1.8rem;\n  accent-color: ", ";\n  cursor: pointer;\n"], ["\n  width: 1.8rem;\n  height: 1.8rem;\n  accent-color: ", ";\n  cursor: pointer;\n"])), theme.colors.primary);
var Dot = styled.button(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  border: none;\n  background: ", ";\n  padding: 0;\n  cursor: pointer;\n"], ["\n  width: 1.2rem;\n  height: 1.2rem;\n  border-radius: 50%;\n  border: none;\n  background: ", ";\n  padding: 0;\n  cursor: pointer;\n"])), function (p) {
    return p.$active ? theme.colors.secondary : theme.colors.gray300;
});
var NavRow = styled(Flex)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  justify-content: center;\n  align-items: center;\n  gap: 1.7rem;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  min-height: min-content;\n"], ["\n  justify-content: center;\n  align-items: center;\n  gap: 1.7rem;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  min-height: min-content;\n"])));
var ChevronIcon = styled(ChevronSvg)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  width: 0.8rem;\n  height: 1.5rem;\n  fill: ", ";\n  transform: ", ";\n"], ["\n  width: 0.8rem;\n  height: 1.5rem;\n  fill: ", ";\n  transform: ", ";\n"])), theme.colors.white, function (p) { return (p.direction === "left" ? "rotate(180deg)" : "none"); });
export default function NewsModal(_a) {
    var _this = this;
    var _b;
    var news = _a.news, isOpen = _a.isOpen, onClose = _a.onClose, onDismissed = _a.onDismissed;
    var t = useTranslation().t;
    var _c = useState(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var _d = useState(false), dontShowAgain = _d[0], setDontShowAgain = _d[1];
    var dismissNewsMutation = useMutation(DISMISS_NEWS)[0];
    var isMobile = useMediaQuery({ query: "(max-width: ".concat(breakpoints.md, ")") });
    var current = news[currentIndex];
    var canPrev = currentIndex > 0;
    var canNext = currentIndex < news.length - 1;
    var handlePrev = useCallback(function () {
        setCurrentIndex(function (i) { return Math.max(0, i - 1); });
    }, []);
    var handleNext = useCallback(function () {
        setCurrentIndex(function (i) { return Math.min(news.length - 1, i + 1); });
    }, [news.length]);
    var handleClose = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dontShowAgain) return [3 /*break*/, 2];
                    return [4 /*yield*/, dismissNewsMutation()];
                case 1:
                    _a.sent();
                    onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
                    _a.label = 2;
                case 2:
                    setCurrentIndex(0);
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); }, [dontShowAgain, dismissNewsMutation, news, onClose, onDismissed]);
    var handleFinish = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dontShowAgain) return [3 /*break*/, 2];
                    return [4 /*yield*/, dismissNewsMutation()];
                case 1:
                    _a.sent();
                    onDismissed === null || onDismissed === void 0 ? void 0 : onDismissed();
                    _a.label = 2;
                case 2:
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); }, [dontShowAgain, dismissNewsMutation, news, onClose, onDismissed]);
    if (!current)
        return null;
    return (React.createElement(ReactModal, { isOpen: isOpen, onRequestClose: handleClose, style: isMobile ? mobileModalStyles : modalStyles, ariaHideApp: false, contentLabel: t("news.title", "Dernières actualités") },
        React.createElement(Header, null,
            React.createElement(CloseButton, { type: "button", onClick: handleClose, "aria-label": t("close") },
                React.createElement(CloseIcon, null)),
            React.createElement(IconWrapper, null,
                React.createElement(Star, { size: "4rem", top: "0.2rem", left: "-2.6rem" }),
                React.createElement(Star, { size: "3.3rem", top: "-0.3rem", right: "-1rem" }),
                React.createElement(Star, { size: "4.3rem", bottom: "-0.1rem", right: "-1.2rem" }),
                React.createElement(BrainIcon, null)),
            React.createElement(Title, { as: "h2", style: {
                    fontSize: "2.2rem",
                    lineHeight: "3.2rem",
                    fontWeight: theme.fontWeights.semibold,
                    fontFamily: theme.fonts.heading,
                } }, t("news.title", "Dernières actualités"))),
        React.createElement(Content, null,
            React.createElement(Box, { css: "display: flex; flex-direction: column; gap: 0.8rem; flex-shrink: 0; min-height: min-content;" },
                React.createElement(NewsDate, null, moment(current.publicationStartDate).format("DD/MM/YYYY")),
                React.createElement(NewsTitle, { as: "h3" }, current.title),
                React.createElement(NewsDescription, { as: "div", dangerouslySetInnerHTML: { __html: (_b = current.content) !== null && _b !== void 0 ? _b : "" } }))),
        React.createElement(Box, { css: "display: flex; flex-direction: column; gap: 3.2rem; flex-shrink: 0;", style: {
                padding: isMobile ? "0.8rem" : "3rem",
                paddingTop: "0",
            } },
            React.createElement(CheckboxLabel, null,
                React.createElement(Checkbox, { checked: dontShowAgain, onChange: function () { return setDontShowAgain(!dontShowAgain); } }),
                t("news.doNotShowAgain", "Ne plus afficher")),
            React.createElement(NavRow, null,
                news.length > 1 && (React.createElement(Button, { type: "button", onClick: handlePrev, disabled: !canPrev, css: "display: inline-flex; align-items: center; gap: 0.8rem;" },
                    React.createElement(ChevronIcon, { direction: "left" }),
                    !isMobile ? t("a11y.swipe_previous") : null)),
                news.length > 1 &&
                    news.map(function (_, i) { return (React.createElement(Dot, { key: i, "$active": i === currentIndex, onClick: function () { return setCurrentIndex(i); }, "aria-label": t("news.goTo", {
                            defaultValue: "Actualité {{index}}",
                            index: i + 1,
                        }) })); }),
                React.createElement(Button, { type: "button", onClick: canNext ? handleNext : handleFinish, css: "display: inline-flex; align-items: center; gap: 0.8rem;" }, canNext ? (React.createElement(React.Fragment, null,
                    !isMobile ? t("a11y.swipe_next") : null,
                    React.createElement(ChevronIcon, { direction: "right" }))) : (t("news.finished")))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;
